import {
	AppstoreOutlined,
	AuditOutlined,
	BarChartOutlined,
	BookOutlined,
	BulbOutlined,
	CalendarOutlined,
	CheckCircleOutlined,
	ClockCircleOutlined,
	CloudOutlined,
	CompassOutlined,
	ControlOutlined,
	CustomerServiceOutlined,
	DashboardOutlined,
	DatabaseOutlined,
	EnvironmentOutlined,
	ExperimentOutlined,
	FileSearchOutlined,
	FileTextOutlined,
	FlagOutlined,
	FolderOutlined,
	GlobalOutlined,
	InboxOutlined,
	InfoCircleOutlined,
	KeyOutlined,
	LockOutlined,
	MailOutlined,
	MessageOutlined,
	NotificationOutlined,
	PieChartOutlined,
	PlayCircleOutlined,
	ProjectOutlined,
	QuestionCircleOutlined,
	ReadOutlined,
	RocketOutlined,
	SafetyOutlined,
	ScheduleOutlined,
	SearchOutlined,
	SettingOutlined,
	TeamOutlined,
	ToolOutlined,
	UserOutlined,
	WarningOutlined,
} from "@ant-design/icons";
import { ComponentType } from "react";

/**
 * The Ant icons a Help Centre topic can show, by component name (the
 * server's `icons` field, such as `RocketOutlined`). They're imported one by
 * one so the bundle carries only these: looking a name up in the whole icon
 * set would pull in all of them. PR 5's icon picker offers this list.
 */
export const HELP_TOPIC_ICONS: Record<string, ComponentType<any>> = {
	AppstoreOutlined,
	AuditOutlined,
	BarChartOutlined,
	BookOutlined,
	BulbOutlined,
	CalendarOutlined,
	CheckCircleOutlined,
	ClockCircleOutlined,
	CloudOutlined,
	CompassOutlined,
	ControlOutlined,
	CustomerServiceOutlined,
	DashboardOutlined,
	DatabaseOutlined,
	EnvironmentOutlined,
	ExperimentOutlined,
	FileSearchOutlined,
	FileTextOutlined,
	FlagOutlined,
	FolderOutlined,
	GlobalOutlined,
	InboxOutlined,
	InfoCircleOutlined,
	KeyOutlined,
	LockOutlined,
	MailOutlined,
	MessageOutlined,
	NotificationOutlined,
	PieChartOutlined,
	PlayCircleOutlined,
	ProjectOutlined,
	QuestionCircleOutlined,
	ReadOutlined,
	RocketOutlined,
	SafetyOutlined,
	ScheduleOutlined,
	SearchOutlined,
	SettingOutlined,
	TeamOutlined,
	ToolOutlined,
	UserOutlined,
	WarningOutlined,
};

/** Shown for a topic with no icon, or one that isn't in the list (Engage's default). */
export const DEFAULT_HELP_TOPIC_ICON = "InboxOutlined";

/** A topic's icon, decorative: the topic's title says what it is. */
export function HelpTopicIcon({ name }: Readonly<{ name?: string }>) {
	const Icon =
		name && Object.prototype.hasOwnProperty.call(HELP_TOPIC_ICONS, name)
			? HELP_TOPIC_ICONS[name]
			: HELP_TOPIC_ICONS[DEFAULT_HELP_TOPIC_ICON];
	return <Icon aria-hidden="true" />;
}
